import React, { useContext, useState } from "react";
import { Button, FloatingLabel, Form } from "react-bootstrap";
import Notiflix from "notiflix";
import PostApiCall from "../../../helper/PostAPI";
import CommonHomeNavbar from "../Navbar/CommonHomeNavbar";
import Footer from "../Footer/Footer";
import { store } from "../../context/store";
import { useNavigate } from "react-router-dom";

export default function Register() {
    let navigate = useNavigate();
    const [customerName, setCustomerName] = useState("");
    const [customerEmail, setCustomerEmail] = useState("");
    const [customerContact, setCustomerContact] = useState("");
    const [consent, setConsent] = useState(false);
    const { clientLogo } = useContext(store)
  return (
    <div className="order-online-page">
    <CommonHomeNavbar />
    <div className="d-flex justify-content-center my-4 px-2 px-lg-0">
      <div className="w-lg-40 w-100 p-lg-5 p-4 color-white">
        {/* <div className="d-flex justify-content-center align-items-center">
            <img src={clientLogo} className="img-fluid w-50 mb-4" alt="logo" />
        </div> */}
          <h2>Hello,</h2>
          <h3>Welcome!</h3>
                <FloatingLabel
                    controlId="floatingInput"
                    label="Name *"
                    className="mb-3">
                    <Form.Control
                    type="text"
                    placeholder="Enter Your Name"
                    value={customerName}
                    onChange={(e) => setCustomerName(e.target.value)}
                />
                </FloatingLabel>
                <FloatingLabel
                  controlId="floatingInput"
                  label="Mobile *"
                  className="mb-3">
                  <Form.Control
                    type="number"
                    placeholder="Enter Your Mobile"
                    value={customerContact}
                    onChange={(e) => setCustomerContact(e.target.value)}
                  />
                </FloatingLabel>
                <FloatingLabel
                  controlId="floatingInput"
                  label="Email Address *"
                  className="mb-3">
                  <Form.Control
                    type="email"
                    placeholder="name@example.com"
                    value={customerEmail}
                    onChange={(e) => setCustomerEmail(e.target.value)}
                  />
                </FloatingLabel>
                <div className="d-flex">
                    <input
                      type="checkbox"
                      className="form-check-input radioBgcolr me-2"
                      checked={consent}
                      onChange={() => {
                        setConsent(!consent);
                      }}></input>
                    <p>
                    I agree to receive SMS updates from Masala of India, including login OTPs, order confirmations, delivery notifications, and promotional offers. Message frequency may vary. Message and data rates may apply. Reply STOP to unsubscribe. Consent is not a condition of purchase.
                    </p>
                  </div>
                          <Button
                      variant="primary"
                      className="w-100 btn btn-danger btn-lg mb-3"
                      onClick={() => {
                        var Order = localStorage.getItem("OrderData");
                        var Orderdetails = JSON.parse(Order);
                        if (
                          customerContact != "" &&
                          customerEmail != "" &&
                          customerName != "" 
                        ) {
                          PostApiCall.postRequest(
                            {
                              name: customerName,
                              email: customerEmail,
                              mobile: customerContact,
                              cartid:
                                localStorage.getItem("OrderData") == null
                                  ? 0
                                  : Orderdetails.order_id,
                              signupguest: "Continue",
                              consent: consent,
                            },
                            "addcustomer"
                          ).then((result) =>
                            result?.json().then((obj3) => {
                              if (
                                result.status == 200 ||
                                result.status == 201
                              ) {
                                localStorage.setItem(
                                  "LoginDetailsWeb",
                                  JSON.stringify(obj3.message)
                                );
                                navigate("/order-online")
                              } else {
                                Notiflix.Notify.Failure("Error Occurred!");
                              }
                            })
                          );
                        } else {
                          Notiflix.Notify.Failure(
                            "Please fill mandatory fields!"
                          );
                        }
                      }}>
                      Continue as Guest
                    </Button>
      </div>
    </div>
    <Footer />
    </div>
  );
}
